export const SpaceSeparator = ({height}) => {
    return(
        <div style={{height: height}}></div>
    )
}
